import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { Bank } from '@ap/interface-bspc-core';

import { PageOfSessions, Session, SessionPatch, SessionStatus } from './sessiebeheer.model';

@Injectable({ providedIn: 'root' })
export class SessiebeheerResource {
    private readonly httpClient = inject(HttpClient);

    private readonly baseUrl: string = '/services/apic-sessiebeheer/api';

    public getSessions(params?: {
        sessionStatusParam?: SessionStatus[];
        bankParam?: Bank;
        limitParam?: number;
        cursorParam?: string;
    }): Observable<PageOfSessions> {
        let httpParams = {};
        let httpHeaders = {};

        if (params && params.sessionStatusParam) {
            httpParams = { ...httpParams, status: params.sessionStatusParam.join(',') };
        }
        if (params && params.limitParam) {
            httpParams = { ...httpParams, limit: params.limitParam };
        }
        if (params && params.cursorParam) {
            httpParams = { ...httpParams, cursor: params.cursorParam };
        }
        if (params && params.bankParam) {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            httpHeaders = { ...httpHeaders, 'X-Bank': params.bankParam };
        }

        return this.httpClient.get<PageOfSessions>(`${this.baseUrl}/sessions`, {
            params: httpParams,
            headers: httpHeaders
        });
    }

    public postSession(
        session: Session,
        params?: {
            bankParam?: Bank;
            authenticationTaskIdHeaderParam?: string;
        }
    ): Observable<void> {
        let httpHeaders = {};

        if (params && params.bankParam) {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            httpHeaders = { ...httpHeaders, 'X-Bank': params.bankParam };
        }
        if (params && params.authenticationTaskIdHeaderParam) {
            httpHeaders = {
                ...httpHeaders,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'X-Authentication-Task-Id': params.authenticationTaskIdHeaderParam
            };
        }

        return this.httpClient.post<void>(`${this.baseUrl}/sessions`, session, {
            headers: httpHeaders
        });
    }

    public getSession(id: string): Observable<Session> {
        return this.httpClient.get<Session>(`${this.baseUrl}/sessions/${id}`);
    }

    public patchSession(id: string, patch: SessionPatch): Observable<void> {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const httpHeaders = { 'Content-Type': 'application/merge-patch+json' };
        return this.httpClient.patch<void>(`${this.baseUrl}/sessions/${id}`, patch, {
            headers: httpHeaders
        });
    }
}
